import * as React from "react";
import type { SVGProps } from "react";
const SvgPencilTitle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={19}
    fill="none"
    {...props}
  >
    <path
      fill="#050033"
      fillOpacity={0.2}
      d="M17.71 5.04c.39-.39.39-1.04 0-1.41l-2.34-2.34c-.37-.39-1.02-.39-1.41 0l-1.84 1.83 3.75 3.75zM0 15.25V19h3.75L14.81 7.93l-3.75-3.75z"
    />
  </svg>
);
export default SvgPencilTitle;
